import React from 'react';
import '../../styles/DocumentsTab.css';

const DocumentsTab = ({ formData, masterData, onChange }) => {
    const renderInput = (field, label, type = 'text') => (
        <div className="form-group">
            <label>{label}</label>
            <input
                type={type}
                value={formData[field] || ''}
                onChange={(e) => onChange(field, e.target.value)}
            />
        </div>
    );

    const renderTextarea = (field, label, rows = 3) => (
        <div className="form-group full-width">
            <label>{label}</label>
            <textarea
                value={formData[field] || ''}
                onChange={(e) => onChange(field, e.target.value)}
                rows={rows}
            />
        </div>
    );

    return (
        <div className="documents-tab">
            <div className="form-section">
                <h3>Bill of Lading / Airway Bill</h3>
                <div className="form-row">
                    {renderInput('MBL', 'Master B/L')}
                    {renderInput('HBL', 'House B/L')}
                </div>
                <div className="form-row">
                    {renderInput('MAWB', 'Master AWB')}
                    {renderInput('HAWB', 'House AWB')}
                </div>
                <div className="form-row">
                    {renderInput('BLDate', 'B/L Date', 'date')}
                    <div className="form-group">
                        <label>B/L Status</label>
                        <select
                            value={formData.BLStatus || ''}
                            onChange={(e) => onChange('BLStatus', e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="Original">Original</option>
                            <option value="Telex Release">Telex Release</option>
                            <option value="Surrendered">Surrendered</option>
                            <option value="Express Release">Express Release</option>
                        </select>
                    </div>
                </div>
            </div>

            <div className="form-section">
                <h3>Delivery & Customs</h3>
                <div className="form-row">
                    {renderInput('DeliveryOrderNo', 'Delivery Order No')}
                    {renderInput('DeliveryOrderDate', 'Delivery Order Date', 'date')}
                </div>
                <div className="form-row">
                    {renderInput('MRN', 'MRN')}
                    {renderInput('RotationNo', 'Rotation No')}
                </div>
                <div className="form-row">
                    {renderInput('IPTNo', 'IPT No')}
                    {renderInput('RefNo', 'Reference No')}
                </div>
            </div>

            <div className="form-section">
                <h3>Financial Details</h3>
                <div className="form-row">
                    {renderInput('CLFValue', 'CLF Value', 'number')}
                    <div className="form-group">
                        <label>Freight</label>
                        <select
                            value={formData.Freight || ''}
                            onChange={(e) => onChange('Freight', e.target.value)}
                        >
                            <option value="">Select</option>
                            <option value="Prepaid">Prepaid</option>
                            <option value="Collect">Collect</option>
                        </select>
                    </div>
                </div>
                <div className="form-row">
                    {renderInput('DepositAmount', 'Deposit Amount', 'number')}
                    {renderInput('DepositDate', 'Deposit Date', 'date')}
                    {renderInput('ReceiptNo', 'Receipt No')}
                </div>
                <div className="form-row">
                    {renderInput('RefundAmount', 'Refund Amount', 'number')}
                    {renderInput('RefundDate', 'Refund Date', 'date')}
                </div>
            </div>

            <div className="form-section">
                <h3>Dates</h3>
                <div className="form-row">
                    {renderInput('SailingDate', 'Sailing Date', 'date')}
                    {renderInput('ArrivalDate', 'Arrival Date', 'date')}
                </div>
                <div className="form-row">
                    {renderInput('CollectionDate', 'Collection Date', 'date')}
                    {renderInput('DeliveryDate', 'Delivery Date', 'date')}
                </div>
            </div>
        </div>
    );
};

export default DocumentsTab;